import Swiper from 'swiper';
const noveltySlider = document.querySelectorAll(".novelty-slider .slider");

if(noveltySlider){
    noveltySlider.forEach((el) => {
        const swiper = new Swiper (el, {
          slidesPerView: 1,
          loop: true,
          centeredSlides: true,
          navigation: {
            nextEl: '.next',
            prevEl: '.prev',
          },
          pagination: {
            el: el.querySelector('.slider-pagination'),
          },
          breakpoints: {
            1024: {
              slidesPerView: 1.7,
              spaceBetween: 40
            },
            1240: {
              slidesPerView: 2.1,
              spaceBetween: 40
            }
          }
        })
    })
}